import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const ContainerSkeleton = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
	margin-top: 50px;

	div {
		height: 180px;
	}
`;

export const ContainerCards = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 24px;
`;
